import { render } from "./artemisadsSegmented.vue?vue&type=template&id=b27cf2c4&scoped=true"
const script = {}

import "./artemisadsSegmented.vue?vue&type=style&index=0&id=b27cf2c4&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b27cf2c4"]])

export default __exports__